"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveEffectOfTypeEffectHandler = exports.RemoveEffectsOfTypeEffectArgs = void 0;
const DurationType_1 = require("../../enums/DurationType");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class RemoveEffectsOfTypeEffectArgs {
    constructor(effectType, skipPermanent) {
        this.effectType = effectType;
        this.skipPermanent = skipPermanent;
        this.__type = EffectType_1.EffectType.RemoveEffectsOfType;
        this.__typeName = "RemoveEffectsOfType";
        this.name = "Remove Effects";
        this.harmful = false;
    }
}
exports.RemoveEffectsOfTypeEffectArgs = RemoveEffectsOfTypeEffectArgs;
let RemoveEffectOfTypeEffectHandler = class RemoveEffectOfTypeEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of container.getEffectsOfType(state.targetId, state.args.effectType)) {
            const effect = container.getEffect(effectId);
            if (state.args.skipPermanent && effect.duration.type === DurationType_1.DurationType.Permanent) {
                continue;
            }
            container.cancelEffect(sequence, effect.id);
        }
    }
    remove(sequence, container, state) { }
};
RemoveEffectOfTypeEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.RemoveEffectsOfType)
], RemoveEffectOfTypeEffectHandler);
exports.RemoveEffectOfTypeEffectHandler = RemoveEffectOfTypeEffectHandler;
